import { c as _c } from "react/compiler-runtime";
import type { EntityBankAccount } from '@onefootprint/types';
import { useTranslation } from 'react-i18next';
import type { AccountLink } from '../bank-account-fields.types';
import DateRow from '../date-row';
import InnerTable from '../inner-table/inner-table';
type AccountStatusProps = {
  links: AccountLink[];
  selectedBankAccount?: EntityBankAccount;
};
const AccountStatus = t0 => {
  const $ = _c(19);
  const {
    links,
    selectedBankAccount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.financial.link"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = isConnected => {
      if (isConnected) {
        return t(_temp);
      }
      return t(_temp2);
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getStateLabel = t2;
  let t3;
  if ($[3] !== t) {
    t3 = productKind => {
      switch (productKind) {
        case "accounts":
          {
            return t(_temp3);
          }
        case "transactions":
          {
            return t(_temp4);
          }
        case "investments":
          {
            return t(_temp5);
          }
        case "identity":
          {
            return t(_temp6);
          }
        case "accountNumbers":
          {
            return t(_temp7);
          }
        default:
          {
            return productKind;
          }
      }
    };
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getProductKindTranslation = t3;
  let t4;
  if ($[5] !== getProductKindTranslation || $[6] !== getStateLabel || $[7] !== links || $[8] !== selectedBankAccount || $[9] !== t) {
    let t5;
    if ($[11] !== selectedBankAccount) {
      t5 = t6 => {
        const {
          accountIds
        } = t6;
        return selectedBankAccount?.alias && accountIds.includes(selectedBankAccount.alias);
      };
      $[11] = selectedBankAccount;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== getProductKindTranslation || $[14] !== getStateLabel || $[15] !== t) {
      t6 = t7 => {
        const {
          errorCode,
          isConnected: isConnected_0,
          linkId,
          productStatuses
        } = t7;
        return <InnerTable key={linkId} title={t(_temp8)} badge={{
          variant: isConnected_0 ? "success" : "error",
          label: getStateLabel(isConnected_0)
        }}>{errorCode && <p className="text-body-2 text-error">Error: {errorCode}</p>}{Object.entries(productStatuses).map(t8 => {
            const [productKind_0, productStatus] = t8;
            const {
              refreshedAt,
              errorMessage
            } = productStatus;
            return refreshedAt ? <div key={productKind_0} className="flex flex-col gap-0.5"><p className="font-medium text-body-2">{getProductKindTranslation(productKind_0)}</p>{refreshedAt ? <DateRow label={t(_temp9)} date={refreshedAt} variant="relative" /> : t(_temp10)}{errorMessage && <p className="text-body-2 text-error">{errorMessage}</p>}</div> : null;
          })}</InnerTable>;
      };
      $[13] = getProductKindTranslation;
      $[14] = getStateLabel;
      $[15] = t;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    t4 = links.filter(t5).map(t6);
    $[5] = getProductKindTranslation;
    $[6] = getStateLabel;
    $[7] = links;
    $[8] = selectedBankAccount;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <>{t4}</>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default AccountStatus;
function _temp($) {
  return $.linkStatus.connected;
}
function _temp2($_0) {
  return $_0.linkStatus.error;
}
function _temp3($_5) {
  return $_5.accounts;
}
function _temp4($_4) {
  return $_4.transactions;
}
function _temp5($_3) {
  return $_3.investments;
}
function _temp6($_2) {
  return $_2.identity;
}
function _temp7($_1) {
  return $_1.accountNumbers;
}
function _temp8($_6) {
  return $_6.linkStatus.title;
}
function _temp9($_7) {
  return $_7.lastRefreshed;
}
function _temp10($_8) {
  return $_8.noData;
}